import {Button, Popover} from "antd";

export function JbButtonWithPopover(props: any) {
  return (
    <Popover content={props.title}>
      <Button {...props} />
    </Popover>
  )
}